// import lodash
import { has } from "lodash";

export default {
    methods: {
        getStatus(patient) {
            // TODO: doing a refactor based on comment https://git.vettersoftware.com/dev/view/-/merge_requests/7966 when available.
            // not doing immediately as need to verify and test
            if (
                patient.isactive === false ||
                (has(patient, "business_patient_isactive") &&
                    patient.business_patient_isactive === false)
            ) {
                return "(deleted)";
            } else if (patient.status === 2 || this.status === 2) {
                return "(inactive)";
            } else if (patient.status === 3 || this.status === 3) {
                return "(deceased)";
            }
            return "";
        }
    }
};
